/* eslint-disable */
<template>
  <div id="side-nav">
    <v-hover>
      <v-navigation-drawer clipped fixed slot-scope="{ hover }" :mini-variant="mini && !hover" id="nav" width="250">
        <v-toolbar
          flat
          height='50px'
          class="transparent hover tabable"
          @click="profile"
          @keyup.enter="profile"
          @keyup.space="profile"
          style="height: 50px; max-height: 50x; padding-top: 0px;"
          tabindex="0"
          :aria-label="`${primaryAccount} profile. Press enter to open the Learner profile.`"
        >
          <v-list v-if="userDataLoaded">
            <v-list-tile class="avatar">
              <v-list-tile-avatar tabindex="0" :aria-label="`${primaryAccount} avatar. Press enter to open the activity feed.`">
                <v-icon v-if="!userImg && primaryAccount !== 'Learner'" large color="white">person</v-icon>
                <img
                  v-if="userImg && primaryAccount !== 'Learner'"
                  class="side-nav-user-avatar"
                  :src=userImg
                  alt="avatar"
                  :key="profilePictureKey"
                  >
                <v-avatar color="white" size="36" v-if="primaryAccount === 'Learner'">
                  <span class="branded-text">{{learnerData.avatarInitials}}</span>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="side-nav-title">{{username}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <!-- Instructor Activity Feed -->
        <div :class="activeView === 'Activity-Feed' ? 'active-div' : 'hover'" v-if="primaryAccount !== 'Learner'">
          <v-list-tile @click="setNavData(['Activity-Feed', 'instructor' , {}])" @keyup.space="setNavData(['Activity-Feed', 'instructor' , {}])" @keyup.enter="setNavData(['Activity-Feed', 'instructor' , {}])" class="tabable" tabindex="0" aria-label="Activity feed.">
            <v-list-tile-action>
              <v-icon  :class="activeView === 'Activity-Feed' ? 'active-icon' : 'white--text'">notifications</v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="side-nav-title">Activity Feed</v-list-tile-title>
          </v-list-tile>
        </div>
        <div :class="primaryAccount === 'Learner' ? 'column-space' : 'column-space column-space-instructor'">
          <v-list v-if="userDataLoaded">
            <!--<div class="divider">-->
            <!--  <div :class="activeView === 'Dashboard' ? 'active-div' : 'hover'"  >-->
            <!--    <v-list-tile  @click="setNavData(['Dashboard', 'dashboard', {}])">-->
            <!--      <v-list-tile-action>-->
            <!--        <img src="//cdn.playposit.com/images/dog_white.png" :class="activeView === 'Dashboard' ? 'active-icon' : 'white--text'" alt="avatar" width="28px">-->
            <!--      </v-list-tile-action>-->
            <!--      <v-list-tile-title class="side-nav-title">Dashboard</v-list-tile-title>-->
            <!--    </v-list-tile>-->
            <!--  </div>-->
            <!--</div>-->
            <div class="divider" v-if="adminPermission">
              <div :class="activeView === 'Administration' ? 'active-div' : 'hover'"    >
                <v-list-tile
                  @click="setNavData(['Administration', 'admin' , {}])"
                  @keyup.enter="setNavData(['Administration', 'admin' , {}])"
                  @keyup.space="setNavData(['Administration', 'admin' , {}])"
                  class="tabable"
                  tabindex="0"
                >
                  <v-list-tile-action>
                    <v-icon  :class="activeView === 'Administration' ? 'active-icon' : 'white--text'">school</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title">Administration</v-list-tile-title>
                </v-list-tile>
              </div>
            </div>
            <div class="divider" v-if="instructorPermission && primaryAccount != 'Learner'" >
              <div :class="activeView === 'My-Bulbs' ? 'active-div' : 'hover'"   >
                <v-list-tile
                  @click="setNavData(['My-Bulbs', 'instructor' , {}])"
                  @keyup.enter="setNavData(['My-Bulbs', 'instructor' , {}])"
                  @keyup.space="setNavData(['My-Bulbs', 'instructor' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="My Bulbs Navigation. Press enter to show the My Bulbs table."
                >
                  <v-list-tile-action>
                    <v-icon  :class="activeView === 'My-Bulbs' ? 'active-icon' : 'white--text'">lightbulb</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title">My Bulbs</v-list-tile-title>
                </v-list-tile>
              </div>
              <div :class="activeView === 'Folders' ? 'active-div' : 'hover'"  v-if="instructorPermission && primaryAccount != 'Learner'">
                <v-list-tile
                  @click="setNavData(['Folders', 'instructor' , {}])"
                  @keyup.enter="setNavData(['Folders', 'instructor' , {}])"
                  @keyup.space="setNavData(['Folders', 'instructor' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="Folders Navigation. Press enter to show the Folders table."
                >
                  <v-list-tile-action>
                    <v-icon  :class="activeView === 'Folders' ? 'active-icon' : 'white--text'">folder</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title">Folders</v-list-tile-title>
                </v-list-tile>
              </div>
              <!--<div :class="activeView === 'My-Videos' ? 'active-div' : 'hover'" >-->
              <!--  <v-list-tile  @click="setNavData(['My-Videos', 'instructor' , {}])" @keyup.enter="setNavData(['My-Videos', 'instructor' , {}])"  class="tabable" tabindex="0" aria-label="My Videos Navigation. Press enter to show the My Videos table.">-->
              <!--    <v-list-tile-action>-->
              <!--      <v-icon :class="activeView === 'My-Videos' ? 'active-icon' : 'white--text'">videocam</v-icon>-->
              <!--    </v-list-tile-action>-->
              <!--    <v-list-tile-title  class="side-nav-title">My Videos</v-list-tile-title>-->
              <!--  </v-list-tile>-->
              <!--</div>-->
              <div :class="activeView === 'Classes' ? 'active-div' : 'hover'" >
                <v-list-tile
                  @click="setNavData(['Classes', 'instructor' , {}])"
                  @keyup.enter="setNavData(['Classes', 'instructor' , {}])"
                  @keyup.space="setNavData(['Classes', 'instructor' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="My Classes Navigation. Press enter to show the class table."
                >
                  <v-list-tile-action>
                    <v-icon  :class="activeView === 'Classes' ? 'active-icon' : 'white--text'">folder_shared</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title  class="side-nav-title">Classes</v-list-tile-title>
                </v-list-tile>
              </div>
              <div v-if="_.get(school, 'config.permissions', []).includes('hasPlaylistAccess')" :class="activeView === 'Playlists' ? 'active-div' : 'hover'"   >
                <v-list-tile
                  @click="setNavData(['Playlists', 'instructor' , {}])"
                  @keyup.enter="setNavData(['Playlists', 'instructor' , {}])"
                  @keyup.space="setNavData(['Playlists', 'instructor' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="Playlist navigation. Press enter to show the playlist table."
                >
                  <v-list-tile-action  >
                    <v-icon :class="activeView === 'Playlist' ? 'active-icon' : 'white--text'">playlist_play</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title" >Playlists</v-list-tile-title>
                </v-list-tile>
              </div>
              <div :class="activeView === 'Premade-Bulbs' ? 'active-div' : 'hover'"   >
                <v-list-tile
                  @click="setNavData(['Premade-Bulbs', 'instructor' , {}])"
                  @keyup.enter="setNavData(['Premade-Bulbs', 'instructor' , {}])"
                  @keyup.space="setNavData(['Premade-Bulbs', 'instructor' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="Premade bulb navigation. Press enter to show the premade bulb table."
                >
                  <v-list-tile-action  >
                    <v-icon  :class="activeView === 'Premade-Bulbs' ? 'active-icon' : 'white--text'">play_circle_outline</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title" >Premade Bulbs</v-list-tile-title>
                </v-list-tile>
              </div>
            </div>
            <div class="divider" v-if="learnerPermission && userDataLoaded">
              <div :class="activeView === 'Learner' ? 'active-div' : 'hover'"  >
                <v-list-tile
                  @click="setNavData(['Learner', 'learner' , {}])"
                  @keyup.enter="setNavData(['Learner', 'learner' , {}])"
                  @keyup.space="setNavData(['Learner', 'learner' , {}])"
                  class="tabable"
                  tabindex="0"
                  aria-label="Learner Classes Navigation. Press enter to show the class table."
                >
                  <v-list-tile-action>
                    <v-icon  :class="activeView === 'Learner' ? 'active-icon' : 'white--text'">{{ instructorType === '' ?  "play_circle_outline"  :  "shop"}}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="side-nav-title">{{ instructorType === '' ?  "My Classes"  :  "Professional Learning"}}</v-list-tile-title>
                </v-list-tile>
              </div>
            </div>
            <div class="hover" v-if="showProfessionalPartnerLink && userDataLoaded" :class="{divider: !learnerPermission}">
              <v-list-tile
                @click="launchPartnerResourcePage"
                @keyup.enter="launchPartnerResourcePage"
                @keyup.space="launchPartnerResourcePage"
                class="tabable"
                tabindex="0"
                aria-label="Partner Resource Page. Press enter to launch resources in a new tab."
              >
                <v-list-tile-action>
                  <v-icon  class="white--text">support</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="side-nav-title">Customer Resources</v-list-tile-title>
              </v-list-tile>
            </div>
            <div class="hover" v-if="shouldDisplayDashboardToggle">
              <v-list-tile
                @click="redirectToNewDashboard"
                @keyup.enter="redirectToNewDashboard"
                @keyup.space="redirectToNewDashboard"
                class="tabable"
                tabindex="0"
                aria-label="Switch over to the new PlayPosit dashboard."
              >
                <v-list-tile-action>
                  <v-icon class="white--text">dashboard</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="side-nav-title">Try New Dashboard</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list>
          <div>
            <!-- This is the button to upgrade a Free account.  Currently waiting on the correct redirect page -->
            <!-- <div class="hover" v-if="instructorType === 'free' && primaryAccount === 'Instructor'">
              <v-list-tile
                @click="openPremium"
                @keyup.enter="openPremium"
                @keyup.space="openPremium"
                class="tabable"
                tabindex="0"
                aria-label="Upgrade button. Press enter to upgrade to pro and open a new upgrade window."
              >
                <v-list-tile-action>
                  <v-icon color="white">stars</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="side-nav-title">Upgrade to Pro</v-list-tile-title></v-list-tile-title>
              </v-list-tile>
            </div> -->
            <div class="hover" v-if="!LTIlaunch">
              <v-list-tile
                @click="handleDialogOpen({type:'confirm', data:{type:'logout'}})"
                @keyup.enter="handleDialogOpen({type:'confirm', data:{type:'logout'}})"
                @keyup.space="handleDialogOpen({type:'confirm', data:{type:'logout'}})"
                class="tabable"
                tabindex="0"
                aria-label="Logout button. Press enter to log out of Play Posit"
              >
                <v-list-tile-action>
                  <v-icon color="white">power_settings_new</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="side-nav-title">Logout</v-list-tile-title>
              </v-list-tile>
            </div>
          </div>
        </div>


      </v-navigation-drawer>
    </v-hover>
  </div>
</template>

<script>
import screenfull from 'screenfull';
import { mapState, mapGetters, mapMutations } from 'vuex';
import Headway from './Headway';
import _ from 'lodash';

import Accessibility from '@/components/mixins/Accessibility';

export default {
  name: 'side-nav',
  components: {
    Headway,
  },
  data() {
    return {
      mini: true,
      drawer: true,
      hover: false,
      profilePictureKey: 1,
    };
  },
  mixins: [
    Accessibility,
  ],
  computed: {
    ...mapState('instructors', [
      'initialView',
    ]),
    ...mapGetters([
      'adminPermission',
      'instructorPermission',
      'instructorData',
      'learnerPermission',
      'primaryAccount',
      'username',
      'userImg',
      'routerView',
      'activeView',
      'learnerData',
      'popoverToggles',
      'userDataLoaded',
      'dialogShow',
      'LTIlaunch',
      'instructorType',
      'school',
      'legacy',
      'userAgent',
    ]),
    ...mapGetters('instructors',[
      'instructorAjaxing',
    ]),
    ...mapGetters('admin',[
      'snapshotLoaded',
    ]),
    showProfessionalPartnerLink() {
      return (
        _.get(this, 'school.id', false)
        && this.instructorType !== '' // instructorType === '' means a learner
      );
    },
    shouldDisplayDashboardToggle() {
      return (
        this.instructorData?.id
        && (
          this.school?.config?.permissions?.includes('defaultToNewDashboard')
          || this.school?.config?.permissions?.includes('showDashboardToggle')
        )
      );
    },
  },
  methods:{
    ...mapMutations([
      'handleDialogOpen',
      'slideOut',
      'updateUserProfilePicture',
    ]),
    ...mapMutations('learners', [
      'setAttemptGetPlaylists',
    ]),
    redirectToNewDashboard() {
      store.set(`teacher${this.instructorData.id}DashboardPreference`, 'new');
      window.location.replace(`${this.$getServerUrl()}dashboard?token=${this.instructorData.token}`);
    },
    launchPartnerResourcePage() {
      window.open('https://go.playposit.com/playposit-partner-resources-brgkyj4fh23qwz3k', '_blank');
    },
    setNavData: function(array) {
      const fabButton = document.getElementsByClassName('BeaconFabButtonFrame')[0];
      if (fabButton) this.setAriaHidden(fabButton, true);
      // Set active view , router view, and query params from menu click
      let activeView = array[0];
      if (activeView === 'Activity-Feed') return this.viewActivityFeed();
      let routerView = array[1];
      let query_params = array[2];

      //sets main nav and breadcrumbs
      this.$store.commit('setNav', [activeView , routerView]);
      let text = activeView.replace('-', ' ');
      this.$store.commit('updateBreadCrumbs' , [[{text: text , disabled: true, payload: ''}], {}]);

      this.popoverToggles.filterMenu = false;
      this.popoverToggles.snapshot = false;
      this.popoverToggles.adminFilterMenu= false;
      switch (routerView) {
        case 'dashboard':
          //if dashboard, update url in main store
          this.$store.dispatch('updateUrl');
          break;
        case 'instructor':
          //if instructor, reset selected data, reset query params
          this.$store.commit('instructors/setSelectedData', []);
          this.$store.commit('instructors/clearAllFiltersNoReload');
          this.$store.commit('instructors/resetQueryParams');
          //set query params and active view
          this.$store.commit('instructors/setQueryParams', query_params);
          this.$store.commit('instructors/setActiveView', [activeView]);
          //get table data, update url
          if (activeView != 'Premade-Bulbs') this.$store.dispatch('instructors/getTableData');
          if (activeView === 'Premade-Bulbs') {
            if (this.school.id) {
              this.$store.commit('instructors/setActiveView', ['My-Community']);
            }
            this.$store.dispatch('instructors/getPremadeTableData', {});
          }
          this.$store.dispatch('instructors/updateUrl');
          break;
        case 'admin':
          //if admin,
          this.$store.commit('admin/clearAllFiltersNoReload');
          this.$store.commit('admin/setQueryParams', query_params);
          this.$store.commit('admin/setActiveView', ['Snapshot']);
          this.$store.dispatch('admin/updateUrl');
          if(!this.snapshotLoaded){
            this.$store.dispatch('admin/getSnapshotData');
          }
          break;
        case 'learner':
          //if learner, set learner breadcrumbs, active view, and query params
          this.$store.commit('updateBreadCrumbs' , [[{text: `${this.learnerData.firstName}'s Classes` , disabled: true, payload: ''}], {}]);
          this.$store.commit('learners/setActiveView', ['Classes']);
          this.$store.commit('learners/resetQueryParams');
          this.$store.commit('learners/setQueryParams', query_params);
          this.setAttemptGetPlaylists(false);
          //get table data and update url
          this.$store.dispatch('learners/getTableData');
          this.$store.dispatch('learners/updateUrl');
          break;
        default:
          break;
      }
    },
    toggleFullscreen: () => {
      screenfull.toggle();
    },
    profile: function() {
      if(this.primaryAccount != 'Learner') {
        //if instructor, opens up profile slide out
        this.$store.commit('slideOut', {toggle: true, view: 'profile'});
      } else {
        //if learner, opens up profile popup
        this.popoverToggles.profile = true;
        this.dialogShow.dash = true;
      }
    },
    viewActivityFeed() {
      this.slideOut({
        toggle: true,
        view: 'activityfeed'
      });
    },
    openPremium: function(){
      window.open(`https://go.playposit.com/pricing?token=${this.instructorData.token}`)
    },
    async iframeMessageReceived(e) {
      if (e.data.message === 'setProfilePicture') {
        this.updateUserProfilePicture(e.data.data);
        await this.$nextTick();
        this.profilePictureKey += 1;
      }
    },
  },
  async mounted() {
    // When we redirect back to the Dash from a PD bulb - open Professional Learning tab
    if (this.initialView === 'PD') this.setNavData(['Learner', 'learner', {}]);
    window.addEventListener('message', this.iframeMessageReceived);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.iframeMessageReceived);
  },
};
</script>

<style lang="scss" scoped>

.side-nav-user-avatar {
  object-fit: cover;
}

</style>